import { Contractor } from "../contract.entities"

import { Contract } from "../contract.entities"

export enum ServiceProviderStatus {
	APPROVED = 'approved',
	PENDING = 'pending',
	DECLINED = 'declined',
	DEACTIVATED = 'deactivated',
	REAPPROVE = 'reapprove',
}

/**
 * Status values for a product's clientAssignment in Content Manager.
 * Kept in sync with api1's product-service ProductStatus — duplicated here
 * because api2 must not depend on api1.
 */
export enum ProductStatus {
	SAVED = 'saved',
	ACTIVE = 'active',
	ACTIVE_SAVED = 'active_saved',
	PENDING = 'pending',
	ARCHIVED = 'archived',
	DEACTIVATED = 'deactivated',
	EXPIRED = 'expired',
}

export type TerminateContractsResult = {
	totalContracts: number,
	terminatedCount: number,
	failedCount: number,
	kafkaEventsSent: number,
	kafkaEventsFailed: number
}

export type CleanupResult = {
	deletedCount: number
	totalThreads: number 
	errors: string[]
}

export type GenerateViewContractsTokenResponse = {
	token: string
	expiresIn: string
	isReadonly: boolean
}

export type GetContractsAndContractorsResponse = {
	contractors: Contractor[],
	contractsByContractor: Record<string, Contract[]>,
	clientNames: Record<string, string>,
	isReadonly: boolean
}

export interface DwhContractorRecord {
	contractorId: string
	serviceProviderId: string | null
	peakId: string | null
	businessName: string | null
	accountHolder: string | null
	iban: string | null
	bic: string | null
	creditInstitution: string | null
	invoiceRecipientName: string | null
	companyEmail: string | null
	companyPhone: string | null
	uidNumber: string | null
	businessOwnerDateOfBirth: string | null
	businessOwnerPlaceOfBirth: string | null
	streetAddress: string | null
	zipCode: string | null
	city: string | null
	country: string | null
	taxId: string | null
	dontHaveUidNumber: boolean
	invoiceRecipientEmail: string | null
}

export type DwhContractStatus = 'signed' | 'unsigned' | 'overdue' | 'terminated'

// optional, combined with AND; without a filter all contracts of the client are returned
export interface DwhContractFilter {
	contractorId?: string
	serviceProviderId?: string
	peakId?: string
}

export interface DwhContractRecord {
	contractId: string
	contractorId: string
	serviceProviderId: string | null
	peakId: string | null
	// internal template name per locale, empty locales as null
	contractTemplateName: Record<string, string | null> | null
	contractStatus: DwhContractStatus
	// ISO 8601 in Europe/Vienna with offset, e.g. 2025-03-08T00:00:00+01:00
	signedAt: string | null
	endDate: string | null
	terminatedAt: string | null
}

export namespace Features {
	export type Feature = {
		id: string
		status: FeatureStatus
	}

	export enum FeatureStatus {
		ENABLED = 'enabled',
		DISABLED = 'disabled',
		BETA = 'beta'
	}

	export enum FeatureEnum {
		SERVICE_DESIGNER_TEMPLATES = 'service-designer-templates',
		SERVICE_PROVIDER_CHECKLIST = 'service-provider-checklist',
		PEAK_SYNC = 'peak-sync',
		CONTRACT_MANAGEMENT = 'contract-management',
		AI_TRANSLATIONS = 'AI-translations',
		AI_PRODUCT_CATEGORIES = 'AI-product-categories',
		AI_CUSTOMER_SEGMENTS = 'AI-customer-segments',
		AI_IMAGE_ENHANCER = 'AI-image-enhancer',
		AI_ALT_TEXT_GENERATION = 'AI-alt-text-generation',
		OPEN_BOOKING = 'open-booking-import'
	}

	export const ClientFeatures = {
		CONTRACT_MANAGEMENT: {
			id: FeatureEnum.CONTRACT_MANAGEMENT,
			status: FeatureStatus.ENABLED
		},
		AI_TRANSLATIONS: {
			id: FeatureEnum.AI_TRANSLATIONS,
			status: FeatureStatus.ENABLED
		},
		AI_PRODUCT_CATEGORIES: {
			id: FeatureEnum.AI_PRODUCT_CATEGORIES,
			status: FeatureStatus.ENABLED
		},
		AI_CUSTOMER_SEGMENTS: {
			id: FeatureEnum.AI_CUSTOMER_SEGMENTS,
			status: FeatureStatus.ENABLED
		},
		AI_IMAGE_ENHANCER: {
			id: FeatureEnum.AI_IMAGE_ENHANCER,
			status: FeatureStatus.ENABLED
		},
		AI_ALT_TEXT_GENERATION: {
			id: FeatureEnum.AI_ALT_TEXT_GENERATION,
			status: FeatureStatus.ENABLED
		},
		OPEN_BOOKING: {
			id: FeatureEnum.OPEN_BOOKING,
			status: FeatureStatus.ENABLED
		}
	} as const
}